import { tickerItems } from "@/mocks/home";

export default function LiveTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="border-b border-background-200 bg-background-100">
      <div className="mx-auto flex w-full items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 border-r border-background-300 py-3 pr-3 md:pr-4">
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-broadcast-line text-base text-primary-600" />
          </span>
          <span className="font-label text-xs font-medium tracking-[0.14em] text-primary-700">
            快讯
          </span>
        </span>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="ticker-track flex w-max items-center gap-8">
            {loop.map((item, index) => (
              <span
                key={`${item.time}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-700 md:text-sm"
              >
                <span className="font-label text-foreground-500">{item.time}</span>
                <span className="h-1 w-1 rounded-full bg-primary-400" />
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}